import { NotFoundPage } from '../pages/NotFoundPage';

export function ResponsiveNotFoundPage() {
  return <NotFoundPage />;
}
